import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
// NOTE: Removed the direct import of CSS for `react-toastify` to fix compilation error.
// Assuming it is handled in the root component or environment.

// FIX: Assuming DynamicForm, ProductConfig, and DeleteConfig are in a single `components` file one level up.
// Adjust the path to '../components' or the correct relative path based on the file structure.
// Since the path was '../../../../components' I will simplify it to relative to the NewProduct component's level.
// However, since I don't know the exact structure, I will attempt to resolve the path based on common React project structure.
// I will keep the original file path '../../../../components' and trust the file exists there when the app runs,
// but for the sake of the immediate compilation, I'll temporarily remove the import and assume these components are globally available or defined elsewhere for now,
// or use a mock definition if possible. Since I cannot mock external components, I will use the path that would typically work in a simplified environment.
// Reverting to the assumption that the necessary components are imported from the original path and fixing the CSS import issue by removing it (as it's often handled globally in these environments).
import { DynamicForm, ProductConfig, DeleteConfig } from '../../../../components';

const ProductProfile = ({
  photo,
  handleImgChange,
  productData, // Data passed from parent (NewEmployee)
  onSubmit, //handleEmployeeProfileSubmit from NewEmployee
  isLoading,
  categories,
  uoms,
  onCancel, //onCancel prop from parent
  control, // control object from the parent 
  errors, // <-- `errors` comes from the parent
  reset, //  `reset` as a prop
  isReadOnly, // for view page.
  deleting  // for delete page 
}) => {
console.log('product  data  sir.',productData)
// Dynamically add department options to ProductConfig
let updatedProductConfig; // Declare outside of the if-else block
if (deleting) {
  updatedProductConfig = DeleteConfig;
} else {
  // Dynamically populate options for UOMs and categories
  updatedProductConfig = ProductConfig?.map(field => {
    // Create a copy of the field to avoid direct mutation
    let updatedField = { ...field };

    // Check if the field is for a UOM
    if (updatedField.name === 'prices_sell_uom_id' || updatedField.name === 'prices_buy_uom_id') {
      updatedField = {
        ...updatedField,
        options: [
          { value: '', label: 'Select UOM', disabled: true, hidden: true },
          ...(Array.isArray(uoms) ? uoms : []),
        ],

      };
    }
    // Check if the field is for a department (as in the original code)
    else if (updatedField.name === 'department_id') {
      updatedField = {
        ...updatedField,
        options: [
          { value: '', label: 'Select Department', disabled: true, hidden: true },
          ...(Array.isArray(categories)? categories :[]),
        ]
  
      };
    }
    return updatedField;
  });
}

//  Use useEffect to reset the form with `productData` when it changes
useEffect(() => {
  if (productData && reset) {
    // Create a flattened data object for react-hook-form
    reset({
      ...productData,
      name: productData.name,
      barcode: productData.barcode,
      category_id: productData.category_id,
      // Map the nested prices data to the top level for the DynamicForm
      prices_buy_uom_id: productData.prices?.buy_uom_id,
      prices_sell_uom_id: productData.prices?.sell_uom_id,
      // FIX: Map the new price fields
      buy_price: productData.prices?.buy_price_new,
      sell_price: productData.prices?.sell_price_new,
      
    });
  }
}, [productData, reset]);
  // --- IMPORTANT: ADD THIS useEffect to log validation errors ---
  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      console.error("EmployeeProfile: Validation Errors detected:", errors);
       toast.error('Please fill in all required fields.');
    }
  }, [errors]);

  // --- IMPORTANT: This function is called by react-hook-form's handleSubmit ---
  const handleFormSubmit = (dataFromForm) => {
    console.log('EmployeeProfile: handleSubmit successfully processed data:', dataFromForm);
    // This is where your actual onSubmit (handleEmployeeProfileSubmit) is called
    onSubmit(dataFromForm);
  };

  //This will call NewEmployee's handleCancel
  const handleProfileCancel = () => {if (onCancel) {onCancel(); }};

  return (
    <form onSubmit={onSubmit} className="space-y-8">
     <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
         {/* Photo Upload Section */}
         <div className="flex flex-col items-center gap-2 bg-white/5 p-4 rounded-xl backdrop-blur-sm table">
          <div className="flex relative group">
            {/* Conditional class for image size is added here */}
            <img
              src={photo}
              alt="Profile"
              className={`${isReadOnly || deleting ? 'h-32 w-32 p-2 ring-4' : 'h-20 w-20 p-1 ring-2'} rounded-full object-cover ring-cyan-400 group-hover:ring-cyan-300 transition duration-300  mx-auto`} 
              />
            {!(isReadOnly || deleting) && (
              <label
                htmlFor="logo-upload"
                className="absolute bottom-0 right-0 bg-cyan-600 p-1 rounded-full shadow-lg cursor-pointer hover:bg-cyan-400 transition"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="currentColor"
                  className="h-4 w-4 text-white"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6.827 6.175A2.31 2.31 0 015.18 8.077L3.465 14.887a2.122 2.122 0 00-.226 1.096v1.391a2.122 2.122 0 002.122 2.122h13.149a2.122 2.122 0 002.122-2.122v-1.391a2.122 2.122 0 00-.226-1.096L18.82 8.077a2.31 2.31 0 01-1.647-1.902V4.5a.75.75 0 00-.75-.75h-8.25a.75.75 0 00-.75.75v1.675zM12 18.5a.75.75 0 110-1.5.75.75 0 010 1.5z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 15a3 3 0 100-6 3 3 0 000 6z"
                  />
                </svg>
                <input
                  id="logo-upload"
                  type="file"
                  name="logo"
                  accept="image/*"
                  onChange={handleImgChange}
                  className="hidden"
                />
              </label>
            )}
          </div>
          {!(isReadOnly || deleting) && (
            <div>
              {/* Increased font size from text-sm to text-base */}
              <p className="text-base text-cyan-200">Upload profile photo</p>
              {/* Increased font size from text-xs to text-sm */}
              <p className="text-sm text-slate-300">Max size: 2MB | Format: JPG, PNG</p>
            </div>
          )}

          </div>

        {/* Manual fields controlled by react-hook-form */}
        <div className="relative space-y-4">
          <div>
            {/* Increased font size from text-sm to text-base */}
            <label htmlFor="name" className="text-base text-cyan-300">Product Name</label>
            {isReadOnly || deleting? (
              // Increased font size to text-lg
              <p className="text-white text-lg">{productData?.name || 'N/A'}</p>
            ) : (
            <Controller
              name="name"
              control={control}
              rules={{ required: 'Product name is required' }} // <-- ADDED validation rules
           
              render={({ field }) => (
                <input
                  {...field}
                  id="name"
                  type="text"
                  // Added text-lg for input text
                  className={`w-full bg-gray-500 text-white border-b-2 focus:outline-none focus:border-cyan-300 border-cyan-500 text-lg`}
                  placeholder="Product Name"
                />
              )}
            />
          )}
            {/* Increased font size from text-xs to text-sm */}
            {errors.name && (
            <p className="text-red-500 text-sm mt-1">{errors.name.message}</p>
          )}
          </div>

          <div>
  {/* Increased font size from text-sm to text-base */}
  <label htmlFor="barcode" className="text-base text-cyan-300">Barcode</label>
  {isReadOnly || deleting ? (
    // Increased font size to text-lg
    <p className="text-white text-lg">{productData?.barcode || 'N/A'}</p>
  ) : (
    <Controller
      name="barcode"
      control={control}
      // No validation rules, barcode is optional
      render={({ field }) => (
        <input
          {...field}
          id="barcode"
          type="text"
          // Added text-lg for input text
          className={`w-full bg-gray-500 text-white border-b-2 focus:outline-none focus:border-cyan-300 border-cyan-500 text-lg`}
          placeholder="Barcode"
        />
      )}
    />
  )}
  {/* Increased font size from text-xs to text-sm */}
  {errors.barcode && (
    <p className="text-red-500 text-sm mt-1">{errors.barcode.message}</p>
  )}
</div>

<div>
  {/* Increased font size from text-sm to text-base */}
  <label htmlFor="product_category" className="text-base text-cyan-300">Product Category</label>
  {isReadOnly || deleting ? (
    // Increased font size to text-lg
    <p className="text-white text-lg">{productData?.product_categories?.name || 'N/A'}</p>
  ) : (
    <Controller
      name="category_id"
      defaultValue={productData?.category_id || ''}
      control={control}
      rules={{ required: 'Product category is required' }}
      render={({ field }) => (
        <select
          {...field}
          id="category_id"
          // Added text-lg for select text
          className={`w-full bg-gray-500 text-white border-b-2 focus:outline-none focus:border-cyan-300 border-cyan-500 text-lg`}   
        >
          <option value="">
            Select product category
          </option>
          {categories?.map(cat => (
            <option key={cat.value} value={cat.value}>
              {cat.label}
            </option>
          ))}
        </select>
      )}
    />
  )}
  {/* Increased font size from text-xs to text-sm */}
  {errors.product_category && (
    <p className="text-red-500 text-sm mt-1">{errors.product_category.message}</p>
  )}
</div>


          
        </div>
      </div>

      {/* The rest of the fields rendered by DynamicForm */}
      <div className="md:col-span-2">
        <DynamicForm
          fields={updatedProductConfig}
          uoms={uoms}
          data={productData}
          onSubmit={handleFormSubmit}
          isLoading={isLoading}
          control={control} // Pass shared control to DynamicForm
          onCancel={handleProfileCancel} // Pass the cancel handler to DynamicForm
          errors={errors} // <-- Pass the errors object 
          isReadOnly={isReadOnly}
        />
      </div>
    </form>
  );
}
export default ProductProfile;
